import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const calendarEasterEgg2022: IPixelMapDay = {
	status: 'special',
	title: "Twenty Twenty-Two: A Meaningful Struggle",
	icon: "favorite",
	reason: "2022, what a year. This was the year that changed everything about my social relationships. Going into it, I didn't expect much from my life, just a normal year to happen. I was so wrong. I was put through a meaningful struggle and I met a person I had wished to meet since forever. It was a reaaaallllyyy rough, disheartening, but fun ride and I wish I had a mood calendar for this. I made so many friends, lost friendships, and gone through so many of love's trials and tribulations. As much as I wish I could go back and re-do this year, I'm happy to have it as one of my core memories.",
	spotify: {
		artist: "Katherine McPhee, Jason Reeves",
		song: "Terrified",
		album: "Unbroken",
		link: "https://open.spotify.com/track/573EXMFHsEKPRSy08G91Sr?si=61a2bfaa425542f3",
	},
	resonatedLyrics: [
		"You by the light is the greatest find",
		"In a world full of wrong, you're the thing that's right",
		"Finally made it through the lonely to the other side",
		"",
		"You said it again, my heart's in motion",
		"Every word feels like a shooting star"
	]
};

export default calendarEasterEgg2022;
